import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useHistory } from 'react-router-dom';

export default function NotFound() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const history = useHistory();

  const handleGoHome = () => {
    history.push('/plataforma');
  };

  const handleGoBack = () => {
    history.goBack();
  };

  const handleSearch = () => {
    history.push('/plataforma');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
      }}>
      <Box
        sx={{
          textAlign: 'center',
          maxWidth: 600,
        }}>
        <Typography
          sx={{
            fontSize: '8rem',
            fontWeight: 700,
            color: theme.palette.primary.main,
            marginBottom: theme.spacing(2),
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
            [theme.breakpoints.down('sm')]: {
              fontSize: '6rem',
            },
            [theme.breakpoints.down('xs')]: {
              fontSize: '4rem',
            },
          }}>
          404
        </Typography>

        <Typography
          sx={{
            fontSize: '2.5rem',
            fontWeight: 600,
            color: theme.palette.text.primary,
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
              fontSize: '2rem',
            },
            [theme.breakpoints.down('xs')]: {
              fontSize: '1.5rem',
            },
          }}>
          Página não encontrada
        </Typography>

        <Typography
          sx={{
            fontSize: '1.2rem',
            color: theme.palette.text.secondary,
            marginBottom: theme.spacing(4),
            lineHeight: 1.6,
            [theme.breakpoints.down('sm')]: {
              fontSize: '1rem',
            },
          }}>
          A página que você está procurando não existe ou foi movida. Verifique
          o endereço ou navegue pelas opções abaixo.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: theme.spacing(2),
            justifyContent: 'center',
            flexWrap: 'wrap',
            [theme.breakpoints.down('xs')]: {
              flexDirection: 'column',
              alignItems: 'center',
            },
          }}>
          <Button
            variant="contained"
            onClick={handleGoHome}
            startIcon={<HomeIcon />}
            sx={(theme) => ({
              padding: theme.spacing(1.5, 3),
              fontSize: '1rem',
              fontWeight: 600,
              borderRadius: theme.spacing(1),
              textTransform: 'none',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
              },
              [theme.breakpoints.down('sm')]: {
                width: '100%',
              },
            })}>
            Ir para o Início
          </Button>

          <Button
            variant="contained"
            onClick={handleSearch}
            startIcon={<SearchIcon />}
            sx={(theme) => ({
              padding: theme.spacing(1.5, 3),
              fontSize: '1rem',
              fontWeight: 600,
              borderRadius: theme.spacing(1),
              textTransform: 'none',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              backgroundColor: theme.palette.secondary.main,
              color: theme.palette.secondary.contrastText,
              '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
              },
              [theme.breakpoints.down('sm')]: {
                width: '100%',
              },
            })}>
            Explorar Conteúdo
          </Button>

          <Button
            variant="outlined"
            onClick={handleGoBack}
            startIcon={<ArrowBackIcon />}
            sx={(theme) => ({
              padding: theme.spacing(1.5, 3),
              fontSize: '1rem',
              fontWeight: 600,
              borderRadius: theme.spacing(1),
              textTransform: 'none',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              border: `2px solid ${theme.palette.primary.main}`,
              color: theme.palette.primary.main,
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
              },
              [theme.breakpoints.down('sm')]: {
                width: '100%',
              },
            })}>
            Voltar
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
